"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var FullPageSpinner_css_1 = __importDefault(require("./FullPageSpinner-css"));
/**
 * Full Page spinner to indicate a loading screen
 *
 */
var FullPageSpinner = function (_a) {
    var loading = _a.loading, styles = _a.styles, indicator = _a.indicator, active = _a.active, className = _a.className, parentElement = _a.parentElement, props = __rest(_a, ["loading", "styles", "indicator", "active", "className", "parentElement"]);
    var internalClasses = FullPageSpinner_css_1.default;
    var ref = react_1.useRef(null);
    var _b = react_1.useState({}), positionStyles = _b[0], setPositionStyles = _b[1];
    react_1.useEffect(function () {
        if (ref.current && !parentElement) {
            setPositionStyles({
                top: ref.current.parentElement.offsetTop,
                left: ref.current.parentElement.offsetLeft,
                width: ref.current.parentElement.offsetWidth,
                height: ref.current.parentElement.offsetHeight
            });
        }
        if (parentElement) {
            setPositionStyles({
                top: parentElement.offsetTop,
                left: parentElement.offsetLeft,
                width: parentElement.offsetWidth,
                height: parentElement.offsetHeight
            });
        }
    }, [loading, active, parentElement]);
    if (active || loading) {
        return (react_1.default.createElement("div", { ref: ref, className: "" + (className || ""), style: __assign(__assign(__assign({}, internalClasses["invosys-ui-FullPageSpinner"]), positionStyles), styles) }, indicator || react_1.default.createElement(CircularProgress_1.default, __assign({}, props))));
    }
    return null;
};
FullPageSpinner.propTypes = {
    loading: prop_types_1.default.bool,
    styles: prop_types_1.default.object,
    indicator: prop_types_1.default.node,
    className: prop_types_1.default.string,
    active: prop_types_1.default.bool,
    parentElement: prop_types_1.default.node
};
exports.default = FullPageSpinner;
